import React, { useEffect } from 'react'
import strings from "../../utils/property-file/manageLeave.json";
import {  useNavigate } from 'react-router-dom';
import constants from '../../utils/constants';
import './scheduleHoliday.css';
import "../color.css";
import { useState } from 'react';
import AddHolidayModal from './addHolidayModal';
import api from '../../services/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import EditHolidayPop from './editHolidayPop';
import SpinnerButtonMedium from '../button/SpinnerButtonMedium';


export default function ScheduleHoliday() {
    const nav=useNavigate();
    const [addHolidayModal , setAddHolidayModal] = useState(false);
    const [isHolidays,  setIsHolidays] = useState(null);
    const [loadingHoliday , setLoadingHoliday] = useState(true);
    const [isDeleteHoliday , setDeleteHoliday] = useState(false);
    const [editHoliday , setEditHoliday] = useState(false);
    const [selectedHolidayId ,setSelectedHolidayId] = useState(null)
    const [spinnerId , setSpinnerId]  = useState(null)
    const [clickedDeleteHoliday , setClickedDeleteHoliday]= useState(false);

    useEffect(()=>{
      getHolidayDetails();
    },[])

    const deleteHoliday =async (holidayId) =>
    {
      setDeleteHoliday(true);
      try
      {
        const body ={
          id : holidayId
        }
        const response = await api.deleteCompanyHoliday(body);
        if(response && response.data) {
          const data = JSON.parse(response.data);
          if(response.success) {
            setDeleteHoliday(false);
            getHolidayDetails();
            toast.success(data.body , {toastId : "error13"})
          }
          else{
            if(response.status_code===440)
            {
              toast.error(data.body , {toastId : "error6"})
              localStorage.clear();
              nav(constants.navigationLink.loginLink);
            }
          }
          setClickedDeleteHoliday(false);
          setDeleteHoliday(false);
        }
      }
      catch(error)
      {
        setDeleteHoliday(false);
        toast.error(strings.somethingWentWrongLabel , {toastId : "error6"})
      }
    }

    const getHolidayDetails = async () =>{
      try {
        const response = await api.getHoliday();
        if(response && response.data) {
          const data = JSON.parse(response.data);
          if(response.success) {
            setIsHolidays(data.body);
          }
          else {
            setIsHolidays(null);
            if(response.status_code===440) {
              toast.error(data.body ,{toastId : "error6"});
              localStorage.clear();
              nav(constants.navigationLink.loginLink);
            }
          }
          setLoadingHoliday(false);
        }
        else {
          toast.error(strings.errorHolidayFetch ,{toastId : "error6"});
          setLoadingHoliday(false);
        }
      }
      catch(error) {
        setLoadingHoliday(false);
        toast.error(strings.somethingWentWrongLabel , {toastId : "error6"})
      }
    }

    return (
        <div>
        {loadingHoliday ? 
        (<div className='holiday-loader'> <div className="spinner-border text-light spinner" role="status">
        <span className="sr-only"></span>
        </div></div>)
        : 
      (<div className="setting-details-sub-container  ">
      {isHolidays!==null ? (
        <>
        <div className="setting-feature">
              <p className="leave-details mb-3"><div onClick={(()=>{ nav(constants.navigationLink.manageLeaves) })} className="back-setting-arrow d-inline"><i className="ri-arrow-left-line"></i></div> {strings.scheduleHoliday} 
              <span className='add-holiday-with-holiday'>
                <button className='btn-add-holiday add-holiday-btn-text' onClick={() => setAddHolidayModal(true)}>
                <i className="ri-add-line  p-1 add-holiday-sign"></i>
                {strings.addHoliday}
              </button>
                <button className='btn-add-holiday-only-icon add-holiday-btn-text' onClick={() => setAddHolidayModal(true)}>
                <i className="ri-add-line  p-1 add-holiday-sign"></i>
              </button>
        </span>  
      </p>
      <div className="all-holiday-list ">
      {isHolidays.map((key , index)=>{
          return(
            <div key={key._id}>
            {!key.isDeleted ? (
              <div className="holiday-list mb-5 mt-1">
             <div className="holiday-details">
             <div className="bookmark-with-date">
             <div className='bookmark-icon'>
                <i className="ri-bookmark-line"></i>
              </div>
              <div className="holiday-dates">
              <div className='dates-for-holiday'>
              {key.leaveType===strings.singleDay ?(
                key.leaveType===strings.singleDay ?moment.utc(key.date[0]).format('MMM, DD YYYY') : ""
               ) : 
                  moment.utc(key.date[0]).format('MMM DD, YYYY')+ " - "+ moment.utc(key.date[key.date.length - 1]).format('MMM, DD YYYY')
                }
              </div>
              
                <div className='holiday-title'>
                {key.title}
                </div>
              <div className='holiday-description'>
                {key.description ? key.description : strings.descriptionLabel}
                </div>
              </div>
             </div>
             </div>
            <div className="edit-delete-button-holiday">
            {clickedDeleteHoliday && spinnerId==index ?
            <>
             <button className='edit-holiday' onClick={(()=>{ 
              deleteHoliday(key._id) ; 
            })}>
            {spinnerId===index ? (isDeleteHoliday ? <SpinnerButtonMedium key={spinnerId===index}/>  :<i className="ri-check-line delete-icons"></i>) : <i className="ri-check-line delete-icons"></i>}
              </button> 
              <button className='delete-holiday' key={key._id} disabled={isDeleteHoliday} onClick={(()=>{
                setClickedDeleteHoliday(false)
                setSpinnerId(index);
                })}>
                <i className="ri-close-line delete-icons"></i>
              </button>
              </>
              : 
              <>
              <button className='edit-holiday' disabled={isDeleteHoliday} onClick={(()=>{setEditHoliday(true); setSelectedHolidayId(key._id)})}>
                <div className='delete-placeholder'>  {strings.editHoliday}</div>
                <div className="delete-icon-responsiveness">
                <i className="ri-edit-line"></i>
                </div>
              </button>
              <button className='delete-holiday' key={key._id} disabled={isDeleteHoliday} onClick={(()=>{
                setClickedDeleteHoliday(true)
                setSpinnerId(index);
                })}>
                <div className='delete-placeholder'>{strings.deleteHoliday}</div>
                <div className="delete-icon-responsiveness">
                <i className="ri-delete-bin-6-line"></i>
                </div>
              </button>
              </>
              }
            </div>
          </div>) : null}
            </div>
          )
        })}
      </div>
        </div>
        </>)
        : 
        (<>
        <div className="schedule-leave-feature">
        <div className="schedule-leave-name">
        <p className="leave-details"><div onClick={(()=>{ nav(constants.navigationLink.manageLeaves) })} className="back-setting-arrow d-inline"><i className="ri-arrow-left-line"></i></div> {strings.scheduleHoliday}</p>
        </div>
        <div className='add-holiday'>
              <div className="add-holiday-icon">
                  <i className="ri-umbrella-line ml-3 icon-manage-leave text-light"></i>
              </div>
              <div className="holiday-message">
                 {strings.messageNoHoliday}
              </div>
              <div className="add-holiday-button">
                  <button onClick={() => setAddHolidayModal(true)}>
                    <i className="ri-add-line p-1 add-holiday-sign"></i>{strings.addHoliday}
              </button>
                </div>
              </div>
        </div>
          </>
          )}
      </div>)}
        {addHolidayModal && <AddHolidayModal  show={addHolidayModal} getHolidayCall={getHolidayDetails} onHide={() => setAddHolidayModal(false)}/>}
        {editHoliday && <EditHolidayPop  show={editHoliday} getHolidayCall={getHolidayDetails} holidayId={selectedHolidayId} onHide={() => setEditHoliday(false)} />}
    </div>
  
    )
}
